import { Component, OnInit, ViewChild } from "@angular/core";
import { NewsService } from "../../../services/news.service";
import { Router } from "@angular/router";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { RoleService } from "../../../services/role.service";
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-role-manager",
  templateUrl: "./role-manager.component.html",
  styleUrls: ["./role-manager.component.scss"],
  animations: [
    trigger('fadeIn', [
      state('void', style({ opacity: 0, transform: 'translateY(20px)' })),
      transition(':enter', [
        animate('0.3s ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ]),
    trigger('tableRow', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-10px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ])
    ])
  ]
})
export class RoleManagerComponent implements OnInit {
  @ViewChild("paginator") paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  roles: MatTableDataSource<any>;
  DATA: any[];
  columnsToDisplay = ["name", "id"];
  totalLength: number = 0;
  isLoading = true;

  skip = 0;
  show = 10;
  search = "";
  size = 1;

  constructor(
    private roleService: RoleService, 
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
    this.roles = new MatTableDataSource();
  }

  ngOnInit() {
    this.loadRoles();
  }

  async loadRoles() {
    try {
      this.spinner.show();
      const data = await this.roleService.getRoles();
      this.setupTableData(data);
    } catch (error) {
      console.error('Error loading roles:', error);
    } finally {
      this.spinner.hide();
    }
  }

  private setupTableData(data: any) {
    this.DATA = data;
    this.roles.data = this.DATA;
    this.roles.sort = this.sort;
    this.roles.paginator = this.paginator;
    this.totalLength = this.DATA.length;
    
    // Custom sort function
    this.roles.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'name': return item.name.toLowerCase();
        default: return item[property];
      }
    };
    
    // Custom filter function
    this.roles.filterPredicate = (data: any, filter: string) => {
      return data.name.toLowerCase().includes(filter);
    };
  }

  doFilter(value: string) {
    this.roles.filter = value.trim().toLowerCase();
  }

  changePage(event: any) {
    this.show = event.pageSize;
    this.skip = event.pageSize * event.pageIndex;
    this.roles.data = this.DATA;
  }

  navigateDetail(row: any) {
    this.router.navigate([`roleEditor/${row.id}`]);
  }
}